import { clsx } from 'clsx';

import type { PropsWithChildren, ReactNode } from 'react';

import styles from './MultiSelect.module.css';

import { MultiSelectItem } from 'components/MultiSelect/components/MultiSelectItem';
import { MultiSelectHeader } from 'components/MultiSelect/components/MultiSelectHeader';

export interface MultiSelectProps {
  /** `true` if the container should scroll on overflow; otherwise, `false` to resize the container to its contents. The default is `true`. */
  scrollable?: boolean;
  /** `true` to disable the border around the container; otherwise, `false`. The default is `false`. */
  noBorder?: boolean;
  /** The header contents. */
  header?: ReactNode;
}

/** Represents a component to list a number of checkboxes. */
export const MultiSelect = ({ scrollable = true, noBorder, header, children }: PropsWithChildren<MultiSelectProps>) => (
  <>
    {header}
    <div
      className={clsx(styles['multi-select'], {
        [styles['multi-select--no-border']]: noBorder,
      })}
    >
      <ul
        className={clsx(styles['multi-select__list'], {
          [styles['multi-select__list--scrollable']]: scrollable,
        })}
        id="multi-select-list"
      >
        {children}
      </ul>
    </div>
  </>
);

MultiSelect.MultiSelectHeader = MultiSelectHeader;
MultiSelect.MultiSelectItem = MultiSelectItem;
